import AuthenticationApi from "../api/AuthenticationApi";
var AppDispatcher = require("../AppDispatcher");
var ActionTypes = require("../constants/ActionTypes");
var EventEmitter = require("events").EventEmitter;
var assign = require("object-assign");

var CHANGE_EVENT = "change";

var AuthenticationStore = assign({}, EventEmitter.prototype, {
  loggedIn() {
    return AuthenticationApi.loggedIn();
  },

  getLang() {
    const supportedLanuages = ["en", "fr", "it", "de"];
    const languageCode = AuthenticationApi.getLang();
    if (languageCode && supportedLanuages.includes(languageCode)) {
      return languageCode;
    }
    return "de";
  },

  getToken() {
    return AuthenticationApi.getToken();
  },

  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  dispatcherIndex: AppDispatcher.register((payload) => {
    switch (payload.actionType) {
      case ActionTypes.AUTHENTICATION_CHANGED:
        AuthenticationStore.emitChange();
        break;

      // add more cases for other actionTypes
    }

    return true; // No errors. Needed by promise in Dispatcher.
  }),
});

export default AuthenticationStore;
